import { useState, useEffect } from 'react';
import debounce from 'lodash/debounce';

import { IPosition } from 'shared/types/Position';

type MouseData = {
  x: number | null;
  y: number | null;
};

const initialMouseState: MouseData = {
  x: null,
  y: null,
};

function getMousePositionFromEvent(e: MouseEvent) {
  const { clientX, clientY } = e;

  return {
    x: clientX,
    y: clientY,
  };
}

export const useMousePosition = (debounceWait: number) => {
  const [position, setPosition] = useState<IPosition>(initialMouseState);

  function updateMousePosition(e: MouseEvent) {
    setPosition(getMousePositionFromEvent(e));
  }

  const debouncedUpdateMousePosition = debounce(updateMousePosition, debounceWait);

  useEffect(() => {
    document.addEventListener('mousemove', debouncedUpdateMousePosition);

    return () => {
      debouncedUpdateMousePosition.cancel();
      document.removeEventListener('mousemove', debouncedUpdateMousePosition);
    };
  }, []);

  return position;
};
